export const DASHBOARD_PATH = "/dashboard"
export const EVENTS_PATH = "/events"
export const EVENT_PATH = "/event/:eventId"
export const PICKS_PATH = "/picks"
export const PICK_PATH = "/event/:eventId/pick/:pickId"
export const STATIONS_PATH = "/stations"
export const STATION_PATH = "/station/:stationId"
export const INFO_PATH = "/info"